import { useEffect, useState } from 'react'
import { supabaseClient } from 'supabaseClient'
import { Group } from 'db-tables'
import { useAuth } from 'hooks/useAuth'

export default function useCreatedGroups(): number {
  const { user } = useAuth()
  const [createdGroups, setCreatedGroups] = useState<number>(0)

  useEffect(() => {
    const fetchCreatedGroups = async (): Promise<void> => {
      if (!user) return
      const { count } = await supabaseClient
        .from<Group>('groups')
        .select('*', { count: 'exact' })
        .eq('owner_id', user.id)
      setCreatedGroups(count ?? 0)
    }
    fetchCreatedGroups()
  }, [user])

  return createdGroups
}
